/**
 * @deprecated use `ControlType` and `Priority` enums instead
 */export var Type=/*#__PURE__*/function(a){return a.PRIMARY="primary",a.PAY="pay",a.SECONDARY="secondary",a.DANGER="danger",a.LINK="link",a}({});